import {createContext} from 'react';
import {ViewStyle} from 'react-native';

export const ModalContext = createContext<{
  open(content: JSX.Element, options?: ModalOptions): void,
  exit(): void,
  visible: boolean;
}>(null);


export interface ModalOptions {
  style?: ViewStyle,
  overlay?: boolean,
  frameless?: boolean,
  forceChoice?: boolean,
}
